/**
 * Local Expert Anonymization
 *
 * The tips are shown as anonymous local insight: the expert's identity (name, age,
 * occupation, neighborhoods...) is never displayed or stored. The tips text starts
 * with the expert's name and age in bold (e.g. "**Travis Bennett, 34**"); these
 * helpers remove that heading.
 */

/**
 * Names the expert may be referred to by in the tips heading, lowercased.
 *
 * @param {Object|null} expert - Local expert profile from the `local_expert` event.
 * @returns {string[]}
 */
export function getExpertNames(expert) {
  if (!expert || typeof expert !== 'object') return [];
  return [expert.name, expert.first_name, expert.nickname]
    .filter((n) => typeof n === 'string' && n.trim())
    .map((n) => n.trim().toLowerCase());
}

/**
 * Removes the leading bold heading that identifies the expert. The heading is removed
 * when it contains one of the expert's names or has the "Name, age" shape, so it is
 * also removed when the `local_expert` event did not arrive.
 *
 * @param {string} content - Tips Markdown.
 * @param {string[]} [names] - Expert names from `getExpertNames()`.
 * @returns {string}
 */
export function stripExpertHeading(content, names = []) {
  if (!content) return content;
  const match = content.match(/^\s*\*\*([^*\n]+)\*\*[ \t]*(\n+|$)/);
  if (!match) return content;
  const heading = match[1].trim().toLowerCase();
  const isExpertHeading = /,\s*\d{1,3}$/.test(heading) || names.some((n) => heading.includes(n));
  return isExpertHeading ? content.slice(match[0].length) : content;
}
